<template>
  <div class="relative inline-block text-left z-20">
    <div @click="toggleOptions($event)" tabindex="0" v-if="showOptions" class="h-screen w-screen top-0 left-0 fixed  z-50">
    </div>
    <div>
      <button v-show="!movable" type="button" @click="toggleOptions"
              class="optionsButton inline-flex justify-center w-full rounded-md border border-gray-300 shadow-sm px-2 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none "
              value="off" aria-expanded="true" aria-haspopup="true">
        ⋮
      </button>
    </div>
    <div v-show="showOptions" class="options">
      <div
          class="origin-top-right z-50 absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white border-2 border-solid border-gray-300 divide-y divide-gray-100 focus:outline-none"
          role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabindex="-1">
        <div class="" role="none">
          <a href="#" @click="toggleMove"
             class="moveTilesButton hover:bg-gray-200 text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem"
             tabindex="-1">
            <svg xmlns="http://www.w3.org/2000/svg" class=" w-5 h-5 mr-3 rotate-45" fill="none"
                 viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round"
                    d="M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"/>
            </svg>
            {{ $t('widget.options.move') }}
          </a>
<!--          <a href="#" @click="editWidget" class="text-gray-700 group flex items-center px-4 py-2 text-sm" role="menuitem"-->
<!--             tabindex="-1">-->
<!--            &lt;!&ndash; Heroicon name: solid/duplicate &ndash;&gt;-->
<!--            <svg xmlns="http://www.w3.org/2000/svg" class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500"-->
<!--                 fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">-->
<!--              <path stroke-linecap="round" stroke-linejoin="round"-->
<!--                    d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"/>-->
<!--            </svg>-->
<!--            Edit-->
<!--          </a>-->
        </div>
        <div class="RemoveButton" role="none">
          <a href="#" @click="removeWidget" class=" hover:bg-gray-200 text-gray-700 group flex items-center px-4 py-2 text-sm"
             role="menuitem" tabindex="-1">
            <!-- Heroicon name: solid/trash -->
            <svg class="mr-3 h-5 w-5 text-gray-400 group-hover:text-gray-500" xmlns="http://www.w3.org/2000/svg"
                 viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path fill-rule="evenodd"
                    d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                    clip-rule="evenodd"/>
            </svg>
            {{ $t('widget.options.delete') }}
          </a>
        </div>
      </div>
    </div>
    <div v-show="movable" class="handle">☰</div>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref} from "vue";

let emit = defineEmits(["clickedMove", "clickedRemove"]);
defineProps( {
  movable: Boolean,
  ShowOptions: Boolean
})

let showOptions = ref(false);
let showMovable = ref(false);


function toggleOptions(e) {
  e.preventDefault();
  showOptions.value = !showOptions.value;
}

function toggleMove(e) {
  e.preventDefault();
  showMovable.value = true;
  showOptions.value = false;
  emit("clickedMove", showMovable.value, showOptions.value);
}

function removeWidget(e)
{
  e.preventDefault();
  emit("clickedRemove", e);
}

</script>
